module.exports = __webpack_public_path__ + "static/media/mira-cgi.0b120bed.jpg";